if (!customElements.get('hero-carousel')) {
  customElements.define(
    'hero-carousel',
    class HeroCarousel extends HTMLElement {
      constructor() {
        super()
      }

      connectedCallback() {
        this.adjustSwiper()
      }

      adjustSwiper() {
        if (this.mainSlider) {
          this.mainSlider
            .querySelectorAll('swiper-slide')
            .forEach((element) => {
              element.classList.remove('hidden')
            })

          Object.assign(this.mainSlider, {
            injectStyles: [
              `
              .swiper-pagination {
                display: flex;
                justify-content: flex-start;
                padding: 0 14px;
                box-sizing: border-box;
              }

              .swiper-pagination-bullet {
                position: relative;
              }

              .swiper-progress-bar {
                position: absolute;
                top: 0;
                left: 0;
                width: 0;
                height: 100%;
                border-radius: var(--swiper-pagination-bullet-border-radius);
                background: var(--swiper-pagination-color);
              }

              .swiper-pagination-bullet-active {
                width: var(--swiper-pagination-active-bullet-width, var(--swiper-pagination-bullet-width, var(--swiper-pagination-bullet-size, 8px)));
                background: transparent;
              }

              .swiper-pagination-bullet-active .swiper-progress-background {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border-radius: var(--swiper-pagination-bullet-border-radius);
                background: var(--swiper-pagination-bullet-inactive-color, #000);
                opacity: var(--swiper-pagination-bullet-inactive-opacity, .2);
              }

              .swiper-pagination-bullet-active .swiper-progress-bar {
                animation-name: countingBar;
                animation-duration: var(--swiper-transition-duration);
                animation-timing-function: ease-in;
                animation-iteration-count: 1;
                animation-direction: alternate;
                animation-fill-mode:forwards;
              }

              @keyframes countingBar {
                0% {width: 0;}
                100% {width:100%;}
              }

              ::slotted(.swiper-slide__deferred-media) {
                height: auto;
              }

              ::slotted(swiper-slide) {
                height: auto;
              }

              @media screen and (min-width: 1460px) {
                .swiper-pagination-bullets.swiper-pagination-horizontal {
                  left: calc((100vw - 1460px) / 2);
                  width: 1460px;
                }
              }
            `,
            ],
            on: {
              slideChange() {
                this.slides.forEach((slide, index) => {
                  // Handle deferred media toggle
                  slide.querySelectorAll('deferred-media').forEach((element) => {
                    if (index === this.realIndex) {
                      element.togglePlayer(false, false); // Play media
                    } else {
                      element.togglePlayer(true); // Pause media
                    }
                  });
            
                  // Handle GIF playback
                  const gifContainer = slide.querySelector('[data-gif-container] img');
                  if (gifContainer && index === this.realIndex) {
                    const baseSrc = gifContainer.dataset.baseSrc;
                    const baseSrcset = gifContainer.dataset.baseSrcset;
                    gifContainer.setAttribute('src', baseSrc.replaceAll('&width', `&reload=${Math.random()}&width`));
                    gifContainer.setAttribute('srcset', baseSrcset.replaceAll('&width', `&reload=${Math.random()}&width`));
                  }
                });
              },
              reachEnd() {
                this.slides.forEach((slide, index) => {
                  if (slide
                    .querySelector('[data-gif-container] img') != undefined){
                    const images = slide
                    .querySelectorAll('[data-gif-container] img');
                    images.forEach((image) => {
                      const baseSrc = image.dataset.baseSrc;
                      const baseSrcset = image.dataset.baseSrcset;
                      image.setAttribute('src', baseSrc.replaceAll('&width', `&reload=${Math.random()}&width`))
                      image.setAttribute('srcset', baseSrcset.replaceAll('&width', `&reload=${Math.random()}&width`))
                    })
                  }
                 
                })
              }
            },
            pagination: {
              renderBullet: function (index, className) {
                return `
                  <span class="${className}">
                    <span class="swiper-progress-background">
                    </span>
                    <span class="swiper-progress-bar">
                    </span>
                  </span>
                `
              },
            },
          })

          const autoplayDuration =
            this.mainSlider.getAttribute('autoplay-delay') || 0
          this.mainSlider.style.setProperty(
            '--swiper-transition-duration',
            `${autoplayDuration}ms`
          )

          this.mainSlider.initialize();
          this.mainSlider.style.opacity = 1;
          this.mainSlider.classList.remove('slider-loading');
          this.mainSlider.querySelector('.swiper-slide-active deferred-media')?.togglePlayer(false, false)
        }
      }

      get mainSlider() {
        return this.querySelector('.js-main-slider')
      }
    }
  )
}
